import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { fontText, StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) =>
  createStyles({
    root: {
      marginLeft: 0,
    },
    formControlLabel: {
      display: 'flex',
      alignItems: 'flex-start',
      marginRight: 0,
      marginLeft: 0,
    },
    expandButton: {
      textDecoration: 'none',
    },
    expandedContentContainer: {
      marginLeft: 32,
      marginTop: 8,
    },
    expandedContent: {
      font: fontText('normal', theme.fontSize.s, 20),
      color: theme.color.greys[60],
      marginBottom: 8,
    },
    dialog: {
      '& .MuiPaper-root': {
        backgroundColor: theme.color.greys[0],
      }
    },
    dialogContentCard: {
      font: fontText('normal', theme.fontSize.base, 24),
      color: theme.color.greys[60],
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        paddingBottom: 116,
      },
    },
    warningIcon: {
      color: theme.color.oranges[50],
    },
    dialogContentDescription: {
      marginBottom: 24,
    },
    formControlDialog: {
      marginLeft: 0,
      marginRight: 0,
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      },
    },
    dialogFooter: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      [theme.breakpoints.down('sm')]: {
        position: 'sticky',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.color.greys[0],
      },
    },
    closeButton: {
      marginTop: 24,
      display: 'flex',
      [theme.breakpoints.down('sm')]: {
        marginTop: 16,
      },
    },
  }), { name: 'ConsentItem', index: StylesIndexInjections.UI_MOLECULES });
